<template>
  <div class="ConferenceRegistration">
    <div class="content" id="content">
      <div class="posi">
        当前位置： 首页 &nbsp;>>&nbsp; 学术与交流 &nbsp;>>&nbsp;
        <span>会议报名</span>
      </div>
      <div class="main">
        <div class="mainList">
          <p>会议报名</p>
          <ul>
            <li
              v-for="(item, index) in speedList"
              :key="index"
              @click="nextOpton(idnex)"
              :class="pimg_Index === index"
            >
              <p v-if="pimg_Index === index"></p>
              {{ item }}
              <img
                src="../assets/image/successImg.png"
                alt=""
                v-if="pimg_Index === index"
              />
            </li>
            <!-- <li id="posiLi">手机验证</li>
            <li>基本信息</li>
            <li>公众号验证</li>
            <li>报名成功</li> -->
          </ul>
          <button type="button" class="pay">线上缴费</button>
        </div>
        <div class="mainForm">
          <div class="verTitle">
            手机验证
            <p></p>
          </div>
          <el-form :model="ruleForm" ref="ruleForm" class="demo-ruleForm">
            <el-form-item prop="telephone">
              <el-input
                v-model="ruleForm.telephone"
                placeholder="请输入账号手机号码"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-input
                class="messageInput"
                v-model="ruleForm.mess"
                placeholder="请输入短信验证码"
              ></el-input>
              <el-button type="text" class="sendOut">发送验证码</el-button>
            </el-form-item>
            <el-form-item>
              <div class="next_back">
                <button type="button" class="next">下一步</button>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ruleForm: {
        telephone: "",
        mess: "",
      },
      speedList: ["手机验证", "基本信息", "公众号验证", "报名成功"],
      pimg_Index: 0,
    };
  },
  mounted() {
    this.$store.commit("SET_HEADERSWITCH", 2);
  },
  methods: {
    nextOpton(idx) {},
  },
};
</script>
<style lang="scss" scoped>
.main {
  margin-top: 50px;
  min-height: 643px;
}

.mainList {
  width: 200px;
  height: 316px;
  border: 1px solid #e5e5e5;
  float: left;
}

.mainList p {
  height: 26px;
  line-height: 26px;
  padding-left: 40px;
  font-size: 26px;
  color: #333333;
  margin: 36px 0 40px 0;
}

.mainList ul {
  height: 215px;
  line-height: 50px;
  font-size: 16px;
}

.mainList ul li {
  padding-left: 38px;
  cursor: pointer;
}

#posiLi {
  color: #e20011;
  font-weight: bold;
  position: relative;
}

#posiLi p {
  width: 0;
  height: 0;
  border-top: 11px solid transparent;
  border-left: 12px solid #e20011;
  border-bottom: 11px solid transparent;
  position: absolute;
  left: 0;
  top: 50%;
  margin: -11px 0 0 0;
}

.successImg {
  color: #e20011;
  position: relative;
}

.successImg img {
  position: absolute;
  right: 20px;
  top: 50%;
  margin-top: -10px;
}

.pay {
  width: 200px;
  height: 40px;
  background-color: #278dfe;
  font-size: 16px;
  color: #ffffff;
  border-radius: 5px;
  margin-top: 26px;
}

.mainForm {
  width: 721px;
  min-height: 643px;
  float: right;
}

.mainForm .verTitle {
  height: 31px;
  border-bottom: 1px solid #e5e5e5;
  font-size: 16px;
  font-weight: bold;
  padding-left: 9px;
  margin: 8px 0 50px 0;
}

.verTitle p {
  width: 40px;
  height: 3px;
  background-color: #e20011;
  margin: 7px 0 0 13px;
}

.messageInput {
  /* margin-left: 30px; */
  position: relative;
}

.sendOut {
  position: absolute;
  right: 20px;
}

.demo-ruleForm .el-form-item {
  width: 402px;
  margin: 0 auto 22px;
}

.demo-ruleForm .el-form-item__content {
  width: 402px;
  margin: 0 !important;
}

.next_back {
  width: 402px;
  height: 50px;
  margin-top: 47px;
  text-align: center;
}

.next_back button {
  width: 210px;
  height: 50px;
  font-size: 18px;
  background-color: #ffffff;
  border-radius: 5px;
}

.next_back /deep/ .next {
  background-color: #e20011;
  color: #ffffff;
}

.el-icon-date:before {
  content: "\e71f";
}

.el-form-item.is-required:not(.is-no-asterisk)
  .el-form-item__label-wrap
  > .el-form-item__label:before,
.el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
  margin-right: 16px;
}

.el-icon-arrow-up:before {
  content: "\e78f";
  color: #999999;
}

#demo-ruleForm {
  width: 525px;
  margin: auto;
}

#demo-ruleForm .el-input {
  width: 400px;
}

#demo-ruleForm .el-input--suffix {
  width: 220px;
}

#demo-ruleForm .el-form-item__label {
  width: 124px !important;
}

#demo-ruleForm .el-form-item__error {
  left: 13px;
}

.webReg .el-form-item__error {
  left: 25px !important;
}

.qrCode {
  width: 398px;
  height: 319px;
  border: 2px dashed #efefef;
  text-align: center;
  font-size: 14px;
  color: #cdcdcd;
  line-height: 36px;
  margin: 16px 0 0 23px;
}

.qrCode img {
  width: 150px;
  height: 142px;
  margin-top: 50px;
}

.textDiv {
  min-height: 565px;
  margin-top: 154px;
}

.text_img {
  text-align: center;
}

.text_img p {
  margin-top: 40px;
  font-size: 24px;
  font-weight: bold;
  color: #278dfe;
}

.back {
  display: block;
  width: 208px;
  height: 48px;
  margin: 80px auto 118px;
  background-color: #ffffff;
  font-size: 17px;
  outline: none;
  border-radius: 5px;
  cursor: pointer;
  color: #666666;
  border: 1px solid #dcdcdc;
}
</style>